import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
const baseFeatures = ['5 Tomos PDF completos', '+200 ejercicios con técnica paso a paso', 'Rutinas de 5 a 30 minutos por nivel', '5 Bonos estratégicos gratis', 'Acceso inmediato', 'Garantía de 7 días'];
const premiumFeatures = ['TODO el Combo Completo Movilidad y Flexibilidad', 'Tests de evaluación de movilidad por zona', '6 rutas personalizadas según tus resultados', 'Programas por perfil: muy rígido, principiante, intermedio y avanzado', 'Hojas de registro semanal y mensual', 'Plan anual con tests trimestrales'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo Completo + Sistema Cuerpo Flexible' : 'Combo Completo Movilidad y Flexibilidad';
  const subtitle = premium ? '5 Tomos + 5 Bonos + Sistema Premium' : '5 Tomos + 5 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$75.000' : '$60.000';
  const savings = premium ? '$47.000' : '$40.000';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-rose bg-primary text-white shadow-[0_25px_60px_rgba(109,40,217,.35)] ring-4 ring-rose-soft/40 md:scale-[1.025]' : 'border border-violet-100 bg-white shadow-sm'}`} data-id="element-232" data-mp="2oosgqqvkya1k">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-pink-100 bg-rose px-4 py-1.5 text-xs font-extrabold text-white shadow-lg" data-id="element-233" data-mp="2tmu77wvc5bn2">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-234" data-mp="33dyk8r1gamf9" /> MÁS ELEGIDO
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-235" data-mp="3hdhgalgzm7b7">
        <div className="flex items-start gap-2" data-id="element-236" data-mp="3ce4yif4z3qfh">
          <span className="text-3xl" data-id="element-237" data-mp="3cfg2aeyf4y6l">{premium ? '💎' : '📚'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-238" data-mp="2a18dgb8qpa4m">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-violet-100' : 'text-slate-500'}`} data-id="element-239" data-mp="2j1dkgka0u6i9">
          {subtitle}
        </p>
      </div>

      <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-violet-50' : 'border-violet-100 bg-violet-50/70 text-slate-600'}`} data-id="element-240" data-mp="2ntetlxbw7h42">
        <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-241" data-mp="32pdykz3ph14z">Ideal para:</b>{' '}
        {premium ? 'Quienes quieren el sistema completo MÁS los tests de evaluación y las rutas personalizadas según su nivel de rigidez, con registro y plan anual medido.' : 'Cualquier persona que quiera moverse mejor, reducir la rigidez y ganar flexibilidad con rutinas listas para hacer en casa o en el gimnasio.'}
      </p>

      <ul className="mb-6 flex-1 space-y-2" data-id="element-242" data-mp="14u7fgcf8rijl">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-243" data-mp="1027ag5kbdzg5">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-pink-200' : 'text-accent'}`} data-id="element-244" data-mp="v105ee9k3ed6" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6 mt-auto" data-id="element-245" data-mp="1npnt0ghs2ftw">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-rose text-white' : 'bg-violet-100 text-primary'}`} data-id="element-246" data-mp="1isf662lopnmb">
          AHORRÁS {savings} ARS
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-violet-200' : 'text-slate-400'}`} data-id="element-247" data-mp="19rh43put3q6d">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-violet-100' : 'text-slate-500'}`} data-id="element-248" data-mp="3uhybf4tt8tl4">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-249" data-mp="1m8gogyf7a8ti">
          {price} <span className="text-base font-bold" data-id="element-250" data-mp="1d9d9a5j5mdka">ARS</span>
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-pink-100 bg-rose text-xs shadow-[0_0_0_5px_rgba(219,39,119,.28)] hover:bg-pink-700' : 'text-xs'} data-id="element-251" data-mp="1d7a8cqggr00s">
        {premium ? 'QUIERO COMBO + SISTEMA CUERPO FLEXIBLE →' : 'QUIERO EL COMBO COMPLETO →'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-252" data-mp="210ioqjl6n3u2">
      <div className="text-center" data-id="element-253" data-mp="kmiqdd1zjm8x">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-254" data-mp="pj925o6rbvoj">
          ⏰ Oferta activa hoy · Precio de lanzamiento
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-255" data-mp="h4la3zbkaqwt">
          Asegurá el precio <span className="text-rose" data-id="element-256" data-mp="r0fv3139cy2r">antes de que suba.</span>
        </h2>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-257" data-mp="qybv2u8hcj7r">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-258" data-mp="3uig84uno7tn8">
              <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-259" data-mp="82vf6jih19ua" />
              {item}
            </span>)}
        </div>
      </div>

      <h2 className="mt-12 text-center text-3xl font-extrabold text-slate-900 md:text-4xl" data-id="element-260" data-mp="390rl4zqwapx">
        Elegí tu <span className="text-rose" data-id="element-261" data-mp="3bou9no9q5u93">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-262" data-mp="36qsl4ntj52q8">
        <PlanCard data-id="element-263" data-mp="1ap7glhmkzvqy" />
        <PlanCard premium data-id="element-264" data-mp="1anmm1s09oct3" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-265" data-mp="1aml73cg4r663">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}